import axios from "axios";
import axiosInstance from "@/services/https/global";
import CONFIG from "../config";

// Real admin-invoice-controller endpoints (see Swagger):
//   GET /invoicing-service/api/v1/wayaquick/admin/invoices
//   GET /invoicing-service/api/v1/wayaquick/admin/invoices/{id}
//   GET /invoicing-service/api/v1/wayaquick/admin/invoices/stats
// src/pages/invoices/data.js still holds MOCK_INVOICES as a rollback —
// see the commented mock implementation at the bottom of this file.
const baseUrl = `${CONFIG.BASE_URL}/invoicing-service/api/v1/wayaquick/admin`;

export const getInvoices = async (params = {}) => {
  const queryParams = {};

  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;
  if (params.status !== undefined) queryParams.status = params.status;
  if (params.merchantId !== undefined)
    queryParams.merchantId = params.merchantId;
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();

  try {
    const response = await axiosInstance.get(`${baseUrl}/invoices`, {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getInvoiceStats = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/invoices/stats`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getInvoiceById = async (id) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/invoices/${id}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

// --- Mock (fallback) — swap back in if the real endpoints regress ---
//
// import { MOCK_INVOICES } from "@/pages/invoices/data";
//
// const MOCK_DELAY_MS = 300;
// const delay = (value) =>
//   new Promise((resolve) => setTimeout(() => resolve(value), MOCK_DELAY_MS));
//
// export const getInvoices = async (params = {}) => {
//   const { page = 0, size = 10, status, search, merchantId } = params;
//   let filtered = MOCK_INVOICES;
//   if (status) filtered = filtered.filter((i) => i.invoiceStatus === status);
//   if (merchantId) filtered = filtered.filter((i) => i.merchantId === merchantId);
//   if (search && search.trim()) {
//     const term = search.trim().toLowerCase();
//     filtered = filtered.filter(
//       (i) =>
//         i.invoiceNumber.toLowerCase().includes(term) ||
//         i.merchantName?.toLowerCase().includes(term) ||
//         i.buyerName?.toLowerCase().includes(term),
//     );
//   }
//   const start = page * size;
//   const data = filtered.slice(start, start + size);
//   return delay({
//     status: true,
//     code: 200,
//     message: "Invoices retrieved successfully",
//     total: filtered.length,
//     pageSize: size,
//     page,
//     data,
//   });
// };
//
// export const getInvoiceStats = async () => {
//   const totalInvoices = MOCK_INVOICES.length;
//   const totalSettled = MOCK_INVOICES.filter((i) => i.invoiceStatus === "SETTLED").length;
//   const totalUnsettled = totalInvoices - totalSettled;
//   const totalValue = MOCK_INVOICES.reduce((sum, i) => sum + Number(i.totalAmount || 0), 0);
//   return delay({
//     status: true,
//     code: 200,
//     message: "Invoice stats retrieved successfully",
//     data: { totalInvoices, totalSettled, totalUnsettled, totalValue },
//   });
// };
//
// export const getInvoiceById = async (id) => {
//   const invoice = MOCK_INVOICES.find((item) => String(item.id) === String(id));
//   return delay({
//     status: Boolean(invoice),
//     code: invoice ? 200 : 404,
//     message: invoice ? "Got Invoice Successfully" : "Invoice not found",
//     data: invoice ?? null,
//   });
// };
